import { gql } from '@apollo/client';

const KEYBOARDING_HOME_USE_SETTING = gql`
  fragment BaseKeyHomeUseSetting on KeySettingHomeUseData {
    KEYK
    KEY1
    KEY2
    KEY3
    KEY4
    KEY5
    contactEmail
  }
`;

export default KEYBOARDING_HOME_USE_SETTING;
